import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import { InputAdornment } from 'material-ui/Input';
import DialogModal from './DialogModal';
import Button from '../Parts/Button'

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
  },

  input: {
    width: '90px',
    fontSize: '15px',
    height: '38px',
    padding: '8px 10px',
    boxSizing: 'border-box',
    border: 'none',
  },

  inputRoot: {
    border: '1px solid #ced4da',
  },

  inputLabel: {
    fontSize: '13px',
    color: '#71737B',
  },

  row: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
  },
});

const maxTotalCount = 1000;
class SelectOptionDialog extends React.Component {
  state = {
    selectCount: this.props.totalCount > maxTotalCount ? maxTotalCount : this.props.totalCount,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isDeleting && !nextProps.isDeleting) {
      this.props.toggleDialog();
    }
  }

  handleChange = property => e => {
    let value = e.target.value;

    if (property === 'selectCount') {
      const maxValue = 49998;
      // レコメンドの件数を合わせて,49,999になるように設定 バックエンドで50,000件以上の選択はできないようにしているため
      if (value > maxValue) {
        value = maxValue;
      } else if (value > this.props.totalCount) {
        value = this.props.totalCount;
      } else if (value < 0) {
        value = 0;
      }
    }
    this.setState({
      [property]: value,
    })
  }

  handleSelect = () => {
    this.props.handleSetSelectOption(this.state);
    this.props.toggleDialog();
  }

  render() {
    const { classes, isOpen, toggleDialog } = this.props;

    return (
      <DialogModal
        title="件数を指定して選択"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <div className={classes.row}>
            <TextField
              id="select-count"
              type="number"
              label="件数"
              InputProps={{
                endAdornment: (<InputAdornment position="start">件</InputAdornment>),
                disableUnderline: true,
                classes: {
                  input: classes.input,
                  root: classes.inputRoot
                },
              }}
              InputLabelProps={{
                shrink: true,
                classes: {
                  root: classes.inputLabel,
                },
              }}
              onChange={this.handleChange("selectCount")}
              value={this.state.selectCount}
              fullWidth
            />
          </div>

          <Button
            text="上から選択"
            handleClickButton={this.handleSelect}
            size="large"
            style={{ margin: "40px 0px 30px 0px", height: '48px' }}
          />
        </div>
      </DialogModal>
    );
  }
}

SelectOptionDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleSetSelectOption: PropTypes.func.isRequired,
  totalCount: PropTypes.number,
  isDeleting: PropTypes.bool,
};

export default withStyles(styles)(SelectOptionDialog);



// WEBPACK FOOTER //
// ./src/components/common/SelectOptionDialog.jsx